import { Link, useParams, useSearchParams } from "react-router-dom";
import { Anchor, Group } from "@mantine/core";
import { IconArrowLeft, IconBuilding } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { UsageOverview } from "@features/Insights";
import { spacePx } from "@xplatform/design-system";

/** One organisation's usage: the dashboard, pinned to it. Loads from the URL alone. */
export const OrganisationDetailPage = () => {
  const { t } = useTranslation();
  const { orgId = "" } = useParams();
  const [params] = useSearchParams();
  const back = new URLSearchParams(params);
  back.delete("org");

  return (
    <UsageOverview
      title={(name) => name ?? orgId}
      description={t("admin.organisations.detailDescription", { id: orgId })}
      icon={<IconBuilding size={28} />}
      organisationId={orgId}
      before={
        <Group>
          <Anchor component={Link} to={`/admin/organisations?${back}`} size="sm">
            <Group gap={spacePx[1]}><IconArrowLeft size={14} />{t("admin.organisations.back")}</Group>
          </Anchor>
        </Group>
      }
    />
  );
};
